import { ContactFormConfig } from '../types/ContactForm';
import { removeFieldsForStep } from '../helpers/fieldHelpers';
import { createStep, removeStep as removeStepHelper, updateStepTitle as updateStepTitleHelper, updateStepDescription as updateStepDescriptionHelper, calculateNewActiveStep } from '../helpers/stepHelpers';

interface UseStepOperationsProps {
    config: ContactFormConfig;
    updateConfig: (property: string, value: unknown) => void;
    activeStep: number;
    setActiveStep: (step: number) => void;
}

export const useStepOperations = ({ config, updateConfig, activeStep, setActiveStep }: UseStepOperationsProps) => {
    const addStep = (): void => {
        const currentSteps = config.steps || [];
        const newStepNumber = currentSteps.length + 1;
        const newStep = createStep(newStepNumber);

        updateConfig('steps', [...currentSteps, newStep]);
        setActiveStep(newStepNumber);
    };

    const removeStep = (stepNumber: number): void => {
        if (!config.steps || config.steps.length <= 1 || stepNumber === 1) return;

        const updatedFields = removeFieldsForStep(config.formFields, stepNumber);
        const updatedSteps = removeStepHelper(config.steps, stepNumber);
        const newActiveStep = calculateNewActiveStep(activeStep, stepNumber);

        updateConfig('formFields', updatedFields);
        updateConfig('steps', updatedSteps);
        setActiveStep(newActiveStep);
    };

    const updateStepTitle = (stepNumber: number, title: string): void => {
        if (!config.steps) return;
        const updatedSteps = updateStepTitleHelper(config.steps, stepNumber, title);
        updateConfig('steps', updatedSteps);
    };

    const updateStepDescription = (stepNumber: number, description: string): void => {
        if (!config.steps) return;
        const updatedSteps = updateStepDescriptionHelper(config.steps, stepNumber, description);
        updateConfig('steps', updatedSteps);
    };

    return {
        addStep,
        removeStep,
        updateStepTitle,
        updateStepDescription
    };
};

